import * as React from 'react'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import ApexCharts from 'apexcharts'
import {
    fetchAnalytes, fetchAnalyteData, fetchSampleChromatogram,
    fetchCalibrationCurve, fetchAllAnalytes, fetchSubmission,
    fetchAnalyteSampleTableData, fetchAnalyteCalibrationCurveData, fetchSubmissionStatus, fetchCleanFlags, fetchSampleFlags,
    getCookie, setCookie, eraseCookie, recalibrateAnalyte, recalculatePeakAreasFIA, recalculatePeakAreasLC, startProfiling, resetCalPoints,
    applyBaselineCorrection, applyNewRtWindow, setLastSelectedSample
} from '../utility';
import ResultsPlotsAndOptions from './ResultsPlotsAndOptions';
import Fuse from 'fuse.js';
import { BsFillQuestionOctagonFill } from 'react-icons/bs'
import { GrUpdate } from 'react-icons/gr'
import { RxUpdate, RxReset } from 'react-icons/rx'
import { BiReset } from 'react-icons/bi'
import { AiFillRedditCircle } from 'react-icons/ai'
import { SiSoundcharts } from 'react-icons/si'
import { TbChartArrowsVertical } from 'react-icons/tb'
import { FaDownload } from 'react-icons/fa'
// import { MdError } from 'react-icons/md';
import { FaCheck, FaBan } from 'react-icons/fa';
import { MdCancel, MdOutlineAppRegistration, MdAppRegistration } from 'react-icons/md'
import ReactDOMServer from 'react-dom/server';
import { MdOutlineAreaChart } from 'react-icons/md'
import { TbRulerMeasure } from 'react-icons/tb'
import { data } from 'jquery';

const MdCancelHTML = ReactDOMServer.renderToString(
    <MdCancel />
)

const MdOutlineAppRegistrationHTML = ReactDOMServer.renderToString(
    <MdOutlineAppRegistration />
)

const MdAppRegistrationHTML = ReactDOMServer.renderToString(
    <MdAppRegistration />
)

const FaCheckHTML = ReactDOMServer.renderToString(
    <FaCheck />
)



const TABLE_ID = "analyte-table"
const FLAGS = { // keys must match with the error codes in the database
    // analyte based error codes
    "analyte_not_found_or_mz_mismatch": "Analyte Not Found or M/Z Mismatch",
    "mass_precursor_or_charge_product_missing": "Mass Precursor or Charge Product Missing",
    "analyte_not_found": "Analyte Not Found",
    "istd_not_found": "Internal Standard Not Found",
    "poor_r_squared": "Poor R² Value",
    "missing_data": "Missing Data",
    "analyte_peak_under_noise_level": "Analyte Peak Under Noise Level",
    "istd_peak_under_noise_level": "Internal Standard Peak Under Noise Level",
    "negative_concentration": "Concentration Below Zero",
    // sample based error codes
    "experimental_outlier": "Analyte Outlier",
    "low_accuracy": "Low Accuracy",
    "blank_conc_error": "LOD could not be calculated as no blank concentrations were found",
    "peak_area_ratio_calculation_error": "Peak Area Ratio Calculation Error",
    "no_chromatogram_data_point_found": "No Chromatogram Data Point Found",
    "low_spectra_to_chromatogram_resolution": "Low Spectra to Chromatogram Resolution",
    "one_spectra_peak_found": "Only One Spectra Peak Found",
    "no_spectra_peaks_found": "No Spectra Peaks Found",
    "low_r2": "Low R²",
    "invalid_chromatogram": "Invalid Chromatogram",
    "invalid_analyte_chromatogram": "Invalid Analyte Chromatogram",
    "invalid_istd_chromatogram": "Invalid Internal Standard Chromatogram",
    "no_peak_picked": "No Peak Picked",
    "istd_invalid_in_blank": "Internal Standard Invalid in Blank",
    "no_calibration_peaks_found": "No Calibration Peaks Found",
    "analyte_not_calibrateable": "Analyte Not Calibrateable",
    "peak_picking_errored": "Peak Picking Errored",
}
const ACTION_TEXT = {
    "apply_new_rt": "apply new retention window",
    "apply_bc": "apply baseline correction",
    "cal_point_removal": "remove calibration point(s)",
    "cal_point_reset": "reset calibration curve",
    "select_sample": "select sample"
}
const CAL_CURVE_ID = "apex-cal-curve"
const CHROM_EXP_ID = "apex-chrom-exp"
const CHROM_STD_ID = "apex-chrom-std"
const DEFAULT_CAL_CURVE_MARKER_SIZE = 10
const EXP_CHROM_TITLE = "Analyte Chromatogram"
const ISTD_CHROM_TITLE = "Internal Standard Chromatogram"
const CAL_CURVE_MARKER_COLOR = "#4596B6"
const CAL_CURVE_MARKER_COLOR_UNFILLED = "#ffffff"
const STATUS_TIMEOUT = 5000
const HMDB_BASE_URL = "https://hmdb.ca/metabolites/"
const CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER = 0.5


export default Submission = (props) => {
    const [SUBMISSION_ID, setSUBMISSION_ID] = React.useState(window.location.pathname.split("/")[2])
    const [submission, setSubmission] = React.useState({})  // submission metadata
    const [IS_FIA, setIS_FIA] = React.useState(false)  // submission metadata
    const [IS_SCIEX, setIS_SCIEX] = React.useState(false) // submission metadata

    const analyteDropdownRef = React.useRef(null)
    const [analytes, setAnalytes] = React.useState([]);  // list of all analytes for dropdown
    const [selectedAnalyte, setSelectedAnalyte] = React.useState({});  // selected analyte
    const [flags, setFlags] = React.useState([]);  // list of flags for selected sample

    const [sampleData, setSampleData] = React.useState([]);  // list of sample data for the sample table for selected analyte only
    const [selectedSample, setSelectedSample] = React.useState('');  // selected sample
    const [sampleChromatogramData, setSampleChromatogramData] = React.useState([]);  // {exp_chrom_data, istd_chrom_data} for selected sample only

    const [calCurveData, setCalCurveData] = React.useState({});  // list of calibration curve data for selected analyte only
    const [calPointStates, setCalPointStates] = React.useState([])

    const [preprocessingComplete, setPreprocessingComplete] = React.useState(false)
    const [table, setTable] = React.useState(null)  // sample table
    const [submissionFileFormat, setSubmissionFileFormat] = React.useState("csv")


    // -- initial page hydration
    React.useEffect(() => {
        // -- STEP 1: getting submission metadata
        fetchSubmission(SUBMISSION_ID)
            .then((submission) => {
                console.log("FROM SUBMISSION: submission", submission)
                setSubmission(submission)
                setSUBMISSION_ID(submission.id)
                setIS_FIA(submission.is_fia)
                setIS_SCIEX(["Sciex Triple Quad 5500/6500", "Sciex Triple Quad 7500"].includes(submission.instrument))
                setPreprocessingComplete(submission.in_profiling_stage)
                // -- polling if submission is queued or profiling
                if (["Preprocessing", "Profiling", "Queued"].includes(submission.status)) {
                    let interval = setInterval(() => {
                        fetchSubmissionStatus(SUBMISSION_ID)
                            .then((status) => {
                                console.log("FROM SUBMISSION: submission", submission)
                                if (["Profiled", "Preprocessed"].includes(status.status)) {
                                    window.location.reload()
                                }
                                if (status.status === "Error") {
                                    alert("There was an error profiling your submission. Please contact support.")
                                    fetchSubmission(SUBMISSION_ID)
                                        .then((submission) => {
                                            console.log("FROM SUBMISSION: submission", submission)
                                            setSubmission(submission)
                                            clearInterval(interval)
                                        })
                                }
                                setSubmission((prev) => {
                                    return { ...prev, status: status.status }
                                })
                            })
                    }, STATUS_TIMEOUT)
                }

                // -- STEP 2: getting all analytes for dropdown
                fetchAllAnalytes(SUBMISSION_ID)
                    .then((analytes) => {
                        console.log("FROM SUBMISSION: analytes", analytes)
                        console.log("FROM SUB: last_action_params", submission.last_action_params)
                        setAnalytes(analytes);  // STEP 3: setting all analytes for dropdown => this will trigger the useEffect in AnalyteSelection
                        // STEP 4: setting selected analyte to previous selected if exists
                        let previousSelectedAnalyte = analytes[0]  // first analyte in dropdown as default
                        if (submission.last_action_params && analytes) {
                            for (let i = 0; i < analytes.length; ++i) {
                                if (parseInt(submission.last_action_params.analyte_id) === analytes[i].id) {
                                    previousSelectedAnalyte = analytes[i]
                                    break
                                }
                            }
                        }
                        console.log("SELECTED ANALYTE2", previousSelectedAnalyte)
                        setSelectedAnalyte(previousSelectedAnalyte)
                        console.log("SELECTED ANALYTE3", selectedAnalyte)

                        // -- STEP 5: getting all sample flags
                        fetchCleanFlags(SUBMISSION_ID)
                            .then((sampleFlags) => {
                                console.log("FROM SUBMISSION: sampleFlags", sampleFlags)
                                window.sampleFlags = sampleFlags
                                setFlags(sampleFlags)

                                if (!submission.IS_FIA && selectedAnalyte.id && selectedAnalyte.name) {  // STEP 6: getting calibration curve data for selected analyte if not FIA
                                    fetchAnalyteCalibrationCurveData(SUBMISSION_ID, selectedAnalyte.id, selectedAnalyte.name)
                                        .then((calCurveData) => {
                                            console.log("FROM SUBMISSION: calCurveData", calCurveData)
                                            setCalCurveData(calCurveData)
                                        })
                                }

                                // -- STEP 7: getting sample data for selected analyte
                                fetchAnalyteSampleTableData(SUBMISSION_ID, selectedAnalyte ? selectedAnalyte.id : analytes[0].id, selectedAnalyte ? selectedAnalyte.name : analytes[0].name)
                                    .then((sampleData) => {
                                        if (submission.last_action_params && submission.last_action_params.sample_id) {
                                            setSelectedSample(parseInt(submission.last_action_params.sample_id));
                                            console.log("FROM SUBMISSION: selectedSample", selectedSample);
                                        }

                                        // -- STEP 8: getting sample chromatogram data for selected sample
                                        if (sampleData.length > 0) {
                                            fetchSampleChromatogram(SUBMISSION_ID, selectedAnalyte.id, selectedSample, selectedSample ? selectedSample : sampleData[0].sample_id)
                                                .then((sampleChromatogramData) => {
                                                    console.log("FROM SUBMISSION: sampleChromatogram", sampleChromatogramData);
                                                    setSampleChromatogramData(sampleChromatogramData);
                                                });
                                        }
                                    });
                            })
                    })
            })
    }, [])


    // -- for updating states when selected analyte is changed
    React.useEffect(() => {
        if (Object.keys(selectedAnalyte).length > 0) {
            if (!IS_FIA) {  // STEP 6: getting calibration curve data for selected analyte if not FIA
                fetchAnalyteCalibrationCurveData(SUBMISSION_ID, selectedAnalyte.id, selectedAnalyte.name)
                    .then((calCurveData) => {
                        // console.log("FROM SUBMISSION: calCurveData", calCurveData)
                        setCalCurveData(calCurveData)
                    })
            }

            // -- STEP 7: getting sample data for selected analyte
            fetchAnalyteSampleTableData(SUBMISSION_ID, selectedAnalyte.id, selectedAnalyte.name)
                .then((sampleData) => {
                    console.log("FROM SUBMISSION: sampleData", sampleData)
                    setSampleData(sampleData)
                    console.log("FROM SUBMISSION: selectedSample", selectedSample)
                    sampleIDs = sampleData.filter((d) => {
                        return d.sample_id === selectedSample
                    }).map((d) => d.sample_id)
                    sampleID = sampleIDs.length > 0 ? sampleIDs[0] : sampleData[0].sample_id  // if selectedSample is not in sampleData, set selectedSample to first sample in sampleData
                    // console.log("FROM SUBMISSION: fetchSampleChromatogram", SUBMISSION_ID, selectedAnalyte.id, selectedSample ? selectedSample : sampleData[0].sample_id)
                    fetchSampleChromatogram(SUBMISSION_ID, selectedAnalyte.id, selectedSample ? selectedSample : sampleData[0].sample_id)
                        .then((sampleChromatogramData) => {
                            console.log("FROM SUBMISSION: sampleChromatogram", sampleChromatogramData)
                            setSampleChromatogramData(sampleChromatogramData)
                        })
                })
        }
    }, [selectedAnalyte])


    // -- for updating states when selected sample is changed
    React.useEffect(() => {
        if (selectedSample != "") {
            fetchSampleChromatogram(SUBMISSION_ID, selectedAnalyte.id, selectedSample)
                .then((sampleChromatogramData) => {
                    console.log("FROM SUBMISSION: sampleChromatogram", sampleChromatogramData)
                    setSampleChromatogramData(sampleChromatogramData)
                })
        }
    }, [selectedSample])

    return (
        <div classname="container-fluid">
            <div className='d-flex' style={{ width: '100%' }}>
                <div className='card sidebar' style={{ width: "20%" }}>
                    <AnalyteSelection
                        IS_FIA={IS_FIA}
                        IS_SCIEX={IS_SCIEX}
                        SUBMISSION_ID={SUBMISSION_ID}
                        submission={submission}
                        preprocessingComplete={preprocessingComplete}
                        setPreprocessingComplete={setPreprocessingComplete}
                        analyteDropdownRef={analyteDropdownRef}
                        analytes={analytes}
                        selectedAnalyte={selectedAnalyte}
                        setSelectedAnalyte={setSelectedAnalyte}
                        selectedSample={selectedSample}
                        flags={flags}
                        calCurveData={calCurveData}
                        table={table}
                        submissionFileFormat={submissionFileFormat}
                        setSubmissionFileFormat={setSubmissionFileFormat}
                    />
                </div>
                <div className="card main-content" style={{ width: "80%", height: "93vh" }}>
                    <div className='d-flex justify-content-between align-items-center px-2' style={{ height: "2.5rem" }}>
                        <h6 className='py-0 m-0'><span style={{ fontWeight: "bold" }}>Name:</span> {submission.name}</h6>
                        <h6 className="py-0 m-0"><span style={{ fontWeight: "bold" }}>Project:</span> {submission.project_name}</h6>
                        <h6 className="py-0 m-0"><span style={{ fontWeight: "bold" }}>Instrument:</span> {submission.instrument}</h6>
                        <h6 className="py-0 m-0"><span style={{ fontWeight: "bold" }}>Assay:</span> {submission.kit_assay}</h6>
                        <h6 className="py-0 m-0"><span style={{ fontWeight: "bold" }}>Panel:</span> {submission.panel}</h6>
                        <h6 className="py-0 m-0"><span style={{ fontWeight: "bold" }}>Biofluid:</span> {submission.biofluid}</h6>
                        <h6 className="py-0 m-0"><span style={{ fontWeight: "bold" }}>Smart Peak Picking:</span> {submission['use_smart_peak_picking'] ? "Yes" : "No"}</h6>
                        <h6 className="py-0 m-0">{submission.area_to_use} - {submission.peak_process_to_use}</h6>
                        <a className="btn btn-warning shadow-lg" style={{ borderRadius: '100px' }} href={`/kit_registrations/${submission.kit_registration_id}`} title="Kit registration">
                            <MdAppRegistration className='fs-1 h-50 w-50' />
                        </a>
                        {/* <h3 className='m-0'><span className='badge rounded-pill text-bg-primary'>Status: {submission.status}</span></h3> */}

                    </div>

                    {/* <AnalyteSelection
                        IS_FIA={IS_FIA}
                        SUBMISSION_ID={SUBMISSION_ID}
                        submission={submission}
                        preprocessingComplete={preprocessingComplete}
                        setPreprocessingComplete={setPreprocessingComplete}
                        analyteDropdownRef={analyteDropdownRef}
                        analytes={analytes}
                        selectedAnalyte={selectedAnalyte} 
                        setSelectedAnalyte={setSelectedAnalyte}  // for setting analyte from dropdown item click
                        flags={flags}  // for setting flags on dropdown items
                        calCurveData={calCurveData}  // for setting calibration curve data on dropdown items
                        table={table}
                    /> */}


                    <div style={{ overflowY: "scroll" }}>
                        <div className="card p-1" style={{}}>
                            <ul className="nav nav-pills nav-fill shadow" style={{ gap: '0.1rem' }} id="results-plots-tabs">
                                <li className="nav-item">
                                    <a className={`nav-link rounded-end active`} id="chrom-nav" data-bs-toggle="pill" data-bs-target="#chromatogram-tab">Chromatogram</a>
                                </li>
                                {!!!IS_FIA && <li className={`nav-item`}>
                                    <a className={`nav-link rounded-start`} id="cal-curve-nav" data-bs-toggle="pill" data-bs-target="#cal-curve-tab" style={{ color: "#212529" }}>Calibration Curve</a>
                                </li>}
                            </ul>
                            <div className="tab-content p-1 pb-0">
                                {!!!IS_FIA &&
                                    <div className={`tab-pane fade`} id="cal-curve-tab" role="tabpanel" aria-labelledby="cal-curve-tab">
                                        <CalibrationCurve
                                            SUBMISSION_ID={SUBMISSION_ID}
                                            IS_FIA={IS_FIA}
                                            IS_SCIEX={IS_SCIEX}
                                            submission={submission}
                                            selectedAnalyte={selectedAnalyte}
                                            calCurveData={calCurveData}
                                            setCalCurveData={setCalCurveData}
                                            preprocessingComplete={preprocessingComplete}
                                            calPointStates={calPointStates}
                                            setCalPointStates={setCalPointStates}
                                        />
                                    </div>
                                }
                                <div className={`tab-pane fade active show`} id="chromatogram-tab" role="tabpanel" aria-labelledby="chromatogram-tab">
                                    <Chromatograms
                                        submission={submission}
                                        SUBMISSION_ID={SUBMISSION_ID}
                                        IS_FIA={IS_FIA}
                                        IS_SCIEX={IS_SCIEX}
                                        selectedSample={selectedSample}
                                        setSelectedSample={setSelectedSample}
                                        selectedAnalyte={selectedAnalyte}
                                        sampleChromatogramData={sampleChromatogramData}
                                        calPointStates={calPointStates}
                                    />
                                </div>
                            </div>
                        </div>
                        <SampleTable
                            SUBMISSION_ID={SUBMISSION_ID}
                            IS_FIA={IS_FIA}
                            IS_SCIEX={IS_SCIEX}
                            selectedAnalyte={selectedAnalyte}
                            selectedSample={selectedSample}
                            setSelectedSample={setSelectedSample}
                            sampleData={sampleData}
                            flags={flags}
                            setTable={setTable}
                            table={table}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}



const SampleTable = (props) => {
    const ACTIVE_VIEW_BTN_CLASS = "bg-primary text-light"
    const [initalSampleScroll, setInitialSampleScroll] = React.useState(true);
    // const [table, setTable] = React.useState(null)

    function handleClickView(e, cell, setSelectedSample) {
        let sampleName = cell.getRow().getData().sample
        let sampleID = cell.getRow().getData().sample_id
        let currentActiveBtn = cell.getTable().element.querySelector(`.${ACTIVE_VIEW_BTN_CLASS.split(" ").join(".")}`)
        if (currentActiveBtn) currentActiveBtn.className = currentActiveBtn.className.replace(` ${ACTIVE_VIEW_BTN_CLASS}`, "")
        let viewBtn = cell.getElement().querySelector("button")
        viewBtn.className = viewBtn.className + ` ${ACTIVE_VIEW_BTN_CLASS}`
        setSelectedSample(sampleID)
        setLastSelectedSample(
            props.SUBMISSION_ID,
            props.selectedAnalyte.id,
            props.selectedAnalyte.name,
            sampleID
        )
            .then((response) => {
                console.log("Set last selected sample", response)
            })
    }

    function actionButtons(cell, formatterParams, onRendered, selectedSample) {
        let classes = "btn btn-light border-dark"
        let rowIdx = cell.getRow().getIndex()
        let sample_id = cell.getRow().getData().sample_id
        if (selectedSample === "" && props.sampleData[0].sample_id === sample_id) {
            // console.log("SAMPLE SAMPLE", sample_id, selectedSample)
            // classes = "btn btn-primary text-light border-dark"
            console.log("ACTION", sample_id, props.selectedSample)
            classes += ` ${ACTIVE_VIEW_BTN_CLASS}`
            cell.getRow().toggleSelect()
        }
        else if (selectedSample === sample_id) {
            classes += ` ${ACTIVE_VIEW_BTN_CLASS}`
            cell.getRow().toggleSelect()
        }
        let html = `
        <div class="btn-group w-100 shadow-sm">
            <button id="sample_btn_${sample_id}" class="${classes}" style="font-size: 0.875rem;">View</button>
        </div>
        `
        return html;
    };

    React.useEffect(() => {
        // Removes the ACTIVE_VIEW_BTN_CLASS from default btn when selectedSample 
        // changes since selectedSample updates after table is initialized. Then
        // adds ACTIVE_VIEW_BTN_CLASS to the selectedSample.
        if (initalSampleScroll == false) {
            return
        }
        const selectedButtons = document.getElementsByClassName(ACTIVE_VIEW_BTN_CLASS)
        let activeButton = null
        if (selectedButtons) {
            activeButton = selectedButtons[0]
        }
        if (activeButton && props.selectedSample) {
            let newActiveButton = document.getElementById(`sample_btn_${props.selectedSample}`)
            if (newActiveButton) {
                let classes = ACTIVE_VIEW_BTN_CLASS.split(' ')
                for (let i = 0; i < classes.length; ++i) {
                    activeButton.classList.remove(classes[i])
                    newActiveButton.classList.add(classes[i])
                    props.table.deselectRow()
                    props.table.getRows().find(row => row.getData().sample_id === props.selectedSample).toggleSelect()
                    const timer = setTimeout(() => {
                        newActiveButton.scrollIntoView({
                            block: 'center',
                        })
                    }, 0)
                }
                setInitialSampleScroll(false)
            }
        }
    }, [props.selectedSample, props.table])

    React.useEffect(() => {
        props.table && props.table.destroy()
        props.setTable(
            renderInitialTable(
                document.getElementById(TABLE_ID),
                props.sampleData,
                handleClickView,
                actionButtons,
                props.setSelectedSample,
                props.selectedSample,
                props.flags,
                props.selectedAnalyte,
                props.IS_FIA,
                props.IS_SCIEX
            )
        )
        setInitialSampleScroll(true)
    }, [props.selectedAnalyte, props.sampleData])

    return (
        <div id={TABLE_ID} />
    )

}

const Chromatograms = (props) => {

    const [expChromPlot, setExpChromPlot] = React.useState(null)
    const [stdChromPlot, setStdChromPlot] = React.useState(null)
    const [expRtMinIdx, setExpRtMinIdx] = React.useState(null)
    const [stdRtMinIdx, setStdRtMinIdx] = React.useState(null)
    const [expAnnotations, setExpAnnotations] = React.useState([])  // [rtx, rtx]
    const [stdAnnotations, setStdAnnotations] = React.useState([])

    const [applyBCToAnalyte, setApplyBCToAnalyte] = React.useState(false)
    const [applyBCToISTD, setApplyBCToISTD] = React.useState(false)
    const [applyBCToAllSamples, setApplyBCToAllSamples] = React.useState(true)

    const [expChromSelection, setExpChromSelection] = React.useState([])
    const [stdChromSelection, setStdChromSelection] = React.useState([])
    // const [expChromSelection, setExpChromSelection] = React.useState({annotations: 0, min: null, max: null})
    // const [stdChromSelection, setStdChromSelection] = React.useState({annotations: 0, min: null, max: null})
    const [applyNewRtToAnalyte, setApplyNewRtToAnalyte] = React.useState(false)
    const [applyNewRtToISTD, setApplyNewRtToISTD] = React.useState(false)
    const [applyNewRtToAllSamples, setApplyNewRtToAllSamples] = React.useState(false)

    // React.useEffect(() => {
    //     console.log("expChromSelection: ", expChromSelection)
    //     console.log("stdChromSelection: ", stdChromSelection)
    // }, [expChromSelection, stdChromSelection])

    React.useEffect(() => {
        console.log("applyBCToAnalyte: ", applyBCToAnalyte)
        console.log("applyBCToISTD: ", applyBCToISTD)
        console.log("applyBCToAllSamples: ", applyBCToAllSamples)
    }, [applyBCToAllSamples, applyBCToAnalyte, applyBCToISTD])

    React.useEffect(() => {
        console.log("applyNewRtToAnalyte: ", applyNewRtToAnalyte)
        console.log("applyNewRtToISTD: ", applyNewRtToISTD)
        console.log("applyNewRtToAllSamples: ", applyNewRtToAllSamples)
    }, [applyNewRtToAllSamples, applyNewRtToAnalyte, applyNewRtToISTD])

    const handleChromSelection = (divId, sampleChromatogramData) => {
        let sampleData;
        if (divId === CHROM_EXP_ID) {
            sampleData = props.sampleChromatogramData["exp_chrom_data"]
            updateChromatogram(expChromPlot, expChromSelection, sampleData.values)
        } else if (divId === CHROM_STD_ID) {
            sampleData = props.sampleChromatogramData["istd_chrom_data"]
            updateChromatogram(stdChromPlot, stdChromSelection, sampleData.values)
        }
    }

    React.useEffect(() => {
        expChromPlot && setExpChromPlot(expChromPlot.destroy())
        // stdChromPlot && !props.IS_FIA && setStdChromPlot(stdChromPlot.destroy())
        stdChromPlot && setStdChromPlot(stdChromPlot.destroy())

        console.log("props.sampleChromatogramData changed: ", props.sampleChromatogramData)
        if (props.sampleChromatogramData?.exp_chrom_data) setExpChromPlot(
            renderChromatogram(props.selectedSample,
                props.sampleChromatogramData["exp_chrom_data"],
                CHROM_EXP_ID, EXP_CHROM_TITLE,
                props.selectedAnalyte.name,
                props.sampleChromatogramData["sample_filename"],
                expChromSelection,
                setExpChromSelection,
                {
                    "noise_level": props.sampleChromatogramData["analyte_noise_level"],
                    "corrected": props.sampleChromatogramData["baseline_corrected"],
                },
                setExpRtMinIdx,
                props.submission.area_to_use, props.IS_FIA
            ))
        // if (!props.IS_FIA && props.sampleChromatogramData?.istd_chrom_data) setStdChromPlot(
        //                                                                         renderChromatogram(props.selectedSample,
        //                                                                                     props.sampleChromatogramData["istd_chrom_data"],
        //                                                                                     CHROM_STD_ID, ISTD_CHROM_TITLE,
        //                                                                                     props.selectedAnalyte.name,
        //                                                                                     props.sampleChromatogramData["sample_filename"],
        //                                                                                     setStdChromSelection,
        //                                                                                     applyBCToAnalyte,
        //                                                                                     applyBCToISTD,
        //                                                                                     props.sampleChromatogramData["istd_noise_level"]
        //                                                 ))
        if (props.sampleChromatogramData?.istd_chrom_data) setStdChromPlot(
            renderChromatogram(props.selectedSample,
                props.sampleChromatogramData["istd_chrom_data"],
                CHROM_STD_ID, ISTD_CHROM_TITLE,
                props.selectedAnalyte.name,
                props.sampleChromatogramData["sample_filename"],
                stdChromSelection,
                setStdChromSelection,
                {
                    "noise_level": props.sampleChromatogramData["istd_noise_level"],
                    "corrected": props.sampleChromatogramData["baseline_corrected_istd"],
                },
                setStdRtMinIdx,
                props.submission.area_to_use, props.IS_FIA
            ))

        setExpAnnotations([])
        setStdAnnotations([])
    }, [props.selectedAnalyte, props.selectedSample, props.sampleChromatogramData])

    React.useEffect(() => {
        window.expChromPlot = expChromPlot
        window.stdChromPlot = stdChromPlot
        console.log("expChromPlot", expChromPlot)
        console.log("stdChromPlot", stdChromPlot)
        try {

            if (expChromPlot != null) {
                expChromPlot.updateOptions({
                    chart: {
                        events: {
                            markerClick: function (event, chartContext, { seriesIndex, dataPointIndex, config }) {
                                if (seriesIndex === 1 || seriesIndex === 2) {
                                    dataPointIndex = dataPointIndex + expRtMinIdx
                                }
                                xValue = props.sampleChromatogramData["exp_chrom_data"].values[dataPointIndex]['x']
                                console.log("xValue: ", xValue, "dataPointIndex: ", dataPointIndex)
                                updateNewRTAnnotations(expChromPlot, xValue, expAnnotations, setExpAnnotations)
                            }
                        }
                    }
                })
            }

            if (stdChromPlot != null) {
                stdChromPlot.updateOptions({
                    chart: {
                        events: {
                            markerClick: function (event, chartContext, { seriesIndex, dataPointIndex, config }) {
                                if (seriesIndex === 1 || seriesIndex == 2) {
                                    dataPointIndex = dataPointIndex + stdRtMinIdx
                                }
                                xValue = props.sampleChromatogramData["istd_chrom_data"].values[dataPointIndex]['x']
                                console.log("xValue: ", xValue, "dataPointIndex: ", dataPointIndex)
                                updateNewRTAnnotations(stdChromPlot, xValue, stdAnnotations, setStdAnnotations)
                            }
                        }
                    }
                })
            }

        } catch (err) {
            console.log("ERRORED OUT")
            console.log(err)
            console.log("expChromPlot", expChromPlot)
            console.log("stdChromPlot", stdChromPlot)
        }

    }, [expChromPlot, stdChromPlot, expAnnotations, stdAnnotations])

    React.useEffect(() => {
        console.log("expAnnotations: ", expAnnotations)
        console.log("stdAnnotations: ", stdAnnotations)

    }, [expAnnotations, stdAnnotations])


    return (
        <div className="d-flex flex-column px-2 rounded-3 border py-1">
            <div className='mb-1 d-flex'>
                <span className='w-50 p-1'>Retention time window: [{props?.sampleChromatogramData?.exp_chrom_data?.rmin?.toFixed(2)}, {props?.sampleChromatogramData?.exp_chrom_data?.rmax?.toFixed(2)}]</span>
                <span className='w-50 p-1'>Retention time window: [{props?.sampleChromatogramData?.istd_chrom_data?.rmin?.toFixed(2)}, {props?.sampleChromatogramData?.istd_chrom_data?.rmax?.toFixed(2)}]</span>
            </div>
            <div className="d-flex" >
                <div className={`${props.IS_FIA ? 'w-50' : 'w-50'} d-inline-block pe-1`}>
                    <div id={CHROM_EXP_ID}></div>
                    <div className="d-flex justify-content-around w-100">
                        <button
                            className="btn btn-danger w-50 shadow-sm ms-1"
                            onClick={() => {
                                // handleChromSelection(CHROM_EXP_ID, props.sampleChromatogramData)
                                expChromPlot.clearAnnotations()
                                setExpAnnotations([])
                            }}
                        >
                            <RxUpdate className="mx-1 d-inline-block text-white align-text-bottom shadow-sm" style={{ fontSize: '1.2rem' }} />
                            <span className="text-shadow">Re-draw Retention Window</span>
                        </button>
                    </div>
                </div>
                {
                    // !props.IS_FIA &&
                    <div className="w-50 d-inline-block ps-1">
                        <div id={CHROM_STD_ID}></div>
                        <div className="d-flex justify-content-around w-100">
                            <button
                                disabled={props.IS_FIA}
                                className="btn btn-success w-50 shadow-sm me-1"
                                onClick={() => {
                                    // handleChromSelection(CHROM_STD_ID, props.sampleChromatogramData)
                                    stdChromPlot.clearAnnotations()
                                    setStdAnnotations([])
                                }}
                            >
                                <RxUpdate className="mx-1 d-inline-block text-white align-text-bottom shadow-sm" style={{ fontSize: '1.2rem' }} />
                                <span className="text-shadow">Re-draw Retention Window</span>
                            </button>
                        </div>
                    </div>
                }
            </div>

            <hr className="my-2" />

            <div className='d-flex gap-1 justify-content-around'>
                <div className='d-flex p-0 border-dark border border-1 w-50 rounded shadow-sm mr-auto justify-content-center'>
                    {
                        !!!props.IS_FIA &&
                        <>
                            <div className='d-flex flex-column p-1 w-50 justify-content-around'>
                                <div className="form-check m-0">
                                    <input className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id="new-rt-analyte"
                                        defaultChecked={applyNewRtToAnalyte}
                                        onClick={() => {
                                            setApplyNewRtToAnalyte(!applyNewRtToAnalyte)
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="new-rt-analyte" style={{ fontSize: "0.875rem" }}>
                                        Apply to <b>Analyte</b>
                                    </label>
                                </div>
                                <div className="form-check m-0">
                                    <input className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id="new-rt-istd"
                                        defaultChecked={applyNewRtToISTD}
                                        onClick={() => {
                                            setApplyNewRtToISTD(!applyNewRtToISTD)
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="new-rt-istd" style={{ fontSize: "0.875rem" }}>
                                        Apply to <b>Internal Standard</b>
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input"
                                        type="checkbox" value=""
                                        id="new-rt-apply-to-all-samples"
                                        defaultChecked={applyNewRtToAllSamples}
                                        onClick={() => {
                                            setApplyNewRtToAllSamples(!applyNewRtToAllSamples)
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="new-rt-apply-to-all-samples" style={{ fontSize: "0.875rem" }}>
                                        Apply to <b>All Sample Files</b>
                                    </label>
                                </div>
                            </div>
                        </>
                    }
                    <div className='d-flex w-50 justify-content-center align-items-center'>
                        <button className='btn btn-info w-75 h-40 text-center shadow-sm'
                            disabled={["Profiling", "Queued_For_Profiling", "Preprocessing", "Queued"].includes(props.submission.status)}
                            onClick={async () => {

                                console.log("SAMPLE_ID >>> NEW RT > > ", props.selectedSample)
                                console.log("windows", expChromSelection, stdChromSelection)

                                if (expAnnotations.length < 2 && applyNewRtToAnalyte) {
                                    alert("Please first re-draw a new retention time window for the analyte chromatogram by clicking on the graph.")
                                    return
                                }
                                if (stdAnnotations.length < 2 && applyNewRtToISTD) {
                                    alert("Please first re-draw a new retention time window for the internal standard chromatogram by clicking on the graph.")
                                    return
                                }
                                if (applyNewRtToAllSamples && !applyNewRtToAnalyte && !applyNewRtToISTD) {
                                    alert("Please re-draw new retention time window for the analyte and/or internal standard chromatogram(s) by clicking on the graph to apply the new retention window(s) to all samples.")
                                    return
                                }
                                if (!applyNewRtToAnalyte && !applyNewRtToISTD && !applyNewRtToAllSamples && !props.IS_FIA) {
                                    alert("Please re-draw new retention time window for the analyte and/or internal standard chromatogram(s) by clicking on the graph. You may also select Apply to All Samples checkbox to apply the new retention time window to all samples.")
                                    return
                                }
                                if (props.IS_FIA && expAnnotations.length < 2) {
                                    alert("Please first re-draw a new retention time window for the analyte chromatogram by clicking on the graph.")
                                    return
                                }

                                applyNewRtWindow(
                                    props.SUBMISSION_ID,
                                    props.selectedAnalyte.id,
                                    props.selectedAnalyte.name,
                                    applyNewRtToAnalyte,
                                    applyNewRtToISTD,
                                    applyNewRtToAllSamples,
                                    props.selectedSample,
                                    `${expAnnotations.length === 2 ? Math.min(...expAnnotations) : 0},${expAnnotations.length === 2 ? Math.max(...expAnnotations) : 0}`,
                                    `${stdAnnotations.length === 2 ? Math.min(...stdAnnotations) : 0},${stdAnnotations.length === 2 ? Math.max(...stdAnnotations) : 0}`,
                                )
                                    .then((response) => {
                                        console.log("response from recalculatePeakAreas-baseline-correction: ", response)
                                        // reload page to update submission status and start polling for status
                                        window.location.reload()
                                    })
                            }}
                        >
                            <TbRulerMeasure className="mx-1 d-inline-block align-text-bottom" style={{ fontSize: '1.2em' }} />
                            Apply New Retention Window
                        </button>
                    </div>
                </div>
                {
                    // !!!props.IS_FIA &&
                    // <div className='d-flex p-0 border-dark border border-1 w-50 rounded shadow-sm mr-auto'>
                    //     {/* <div className='d-flex flex-column p-1 w-50 justify-content-around'>
                    //         <div className="form-check m-0">
                    //             <input className="form-check-input" 
                    //                 type="checkbox" 
                    //                 value="" 
                    //                 id="bc-analyte"
                    //                 defaultChecked={applyBCToAnalyte}
                    //                 onClick={() => {
                    //                     setApplyBCToAnalyte(!applyBCToAnalyte)
                    //                 }}
                    //             />
                    //             <label className="form-check-label" htmlFor="bc-analyte" style={{fontSize: "0.875rem"}}>
                    //                 Apply to <b>Analyte</b>
                    //             </label>
                    //         </div>
                    //         <div className="form-check m-0">
                    //             <input className="form-check-input" 
                    //                 type="checkbox" 
                    //                 value="" 
                    //                 id="bc-istd"
                    //                 defaultChecked={applyBCToISTD}
                    //                 onClick={() => {
                    //                     setApplyBCToISTD(!applyBCToISTD)
                    //                 }}
                    //             />
                    //             <label className="form-check-label" htmlFor="bc-istd" style={{fontSize: "0.875rem"}}>
                    //                 Apply to <b>Internal Standard</b>
                    //             </label>
                    //         </div>
                    //         <div className="form-check m-0">
                    //             <input className="form-check-input" 
                    //                 type="checkbox" value="" 
                    //                 id="bc-apply-to-all-samples"
                    //                 defaultChecked={applyBCToAllSamples}  
                    //                 onClick={() => {
                    //                     setApplyBCToAllSamples(!applyBCToAllSamples)
                    //                 }}  
                    //             />
                    //             <label className="form-check-label" htmlFor="bc-apply-to-all-samples " style={{fontSize: "0.875rem"}}>
                    //                 Apply to <b>All Sample Files</b>
                    //             </label>
                    //         </div>
                    //     </div> */}
                    //     <div className='d-flex w-100 justify-content-center align-items-center'>
                    //         <button className='btn btn-info w-50 h-40 text-center shadow-sm'
                    //             disabled={["Profiling", "Queued_For_Profiling", "Preprocessing", "Queued"].includes(props.submission.status) || props.selectedAnalyte.baseline_corrected }
                    //             onClick={async() => {
                    //                 applyBaselineCorrection(
                    //                     props.SUBMISSION_ID,
                    //                     props.selectedAnalyte.id,
                    //                     props.selectedAnalyte.name,
                    //                     applyBCToAnalyte,
                    //                     applyBCToISTD,
                    //                     applyBCToAllSamples,
                    //                     props.selectedSample,
                    //                     JSON.stringify(props.calPointStates)
                    //                 )
                    //                 .then((response) => {
                    //                     console.log("response from recalculatePeakAreas-baseline-correction: ", response)
                    //                     // reload page to update submission status and start polling for status
                    //                     window.location.reload()
                    //                 })

                    //             }}
                    //         >
                    //             <MdOutlineAreaChart className="mx-1 d-inline-block align-text-bottom" style={{fontSize: '1.2rem'}}/>
                    //             {props.selectedAnalyte.baseline_corrected ? "Baseline Corrected" : "Apply Baseline Correction"}
                    //         </button>
                    //     </div>
                    // </div>
                }
            </div>
        </div>
    )
}

const CalibrationCurve = (props) => {

    const [calCurvePlot, setCalCurvePlot] = React.useState(null)
    const [applyToAllAnalytes, setApplyToAllAnalytes] = React.useState(false)
    // const [calPointStates, setCalPointStates] = React.useState([])
    const { calPointStates, setCalPointStates } = props

    const handleCalPointHover = (chart, calPointStates, pointIdx, event) => {
        // console.log("data from handleCalPointHover: ", calPointStates, pointIdx, event)
        chart.updateOptions({
            markers: {
                discrete: calPointStates.map((point, i) => {
                    return {
                        seriesIndex: 0,
                        dataPointIndex: i,
                        fillColor: point.selected ? CAL_CURVE_MARKER_COLOR : CAL_CURVE_MARKER_COLOR_UNFILLED,
                        fillOpacity: point.selected ? 1 : 0.5,
                        size: (i === pointIdx) ? (event === "enter" ? DEFAULT_CAL_CURVE_MARKER_SIZE * 2 : DEFAULT_CAL_CURVE_MARKER_SIZE) : DEFAULT_CAL_CURVE_MARKER_SIZE,
                    }
                })
            },
        })
    }

    const handleCalPointStateChange = (selectedPoint, calCurvePlot) => {
        console.log("pointIdx: ", selectedPoint)
        setCalPointStates(calPointStates.map((point, idx) => {
            // if (idx === pointIdx) {
            //     return !point.selected
            // }
            // return point.selected
            if (point.idx === selectedPoint.idx) {
                return {
                    ...point,
                    selected: !point.selected + false
                }
            } else {
                return point
            }
        }))
    }

    React.useEffect(() => {
        // console.log("calPointStates changed: ", calPointStates)
        console.log("applyToAllAnalytes changed: ", applyToAllAnalytes)
    }, [calPointStates, applyToAllAnalytes])


    React.useEffect(() => {
        calCurvePlot && setCalCurvePlot(() => {
            calCurvePlot.destroy()
            return null
        })
        console.log("props.calcurvedata changed: ", props.calCurveData)
        if (Object.keys(props.calCurveData).length > 0) {
            console.log("props.calCurveData: rendering cal curve", props.calCurveData)
            // setCalPointStates(JSON.parse(props.calCurveData.cal_points))
            setCalPointStates(props.calCurveData.cal_points)
            setCalCurvePlot(renderCalCurve(props.calCurveData, CAL_CURVE_ID, props.selectedAnalyte.name))
        }
    }, [props.calCurveData, props.selectedAnalyte])


    return (
        <div className="d-flex">
            <div className="pe-3 w-50">
                <div className="d-flex justify-content-between p-1">
                    <h5>Calibration Points</h5>
                    {!!!props.IS_FIA && <h5 className={`${parseFloat(props.calCurveData["r_squared"]) < 0.99 && parseFloat(props.calCurveData["r_squared"]) >= 0.95 && 'rq_flag_warning'} ${parseFloat(props.calCurveData["r_squared"]) < 0.95 && 'rq_flag_critical'}`} style={{ borderRadius: '6px', padding: '1px 5px' }}>R<sup>2</sup> = {parseFloat(props.calCurveData["r_squared"]).toFixed(4)}</h5>}
                </div>
                <div>
                    {calPointStates ? calPointStates.map((d, i) => {
                        return (
                            <div className="btn btn-outline-dark form-check d-flex align-items-center" style={{ height: '2.625vh' }}
                                key={`calcurve-check-container-${d.x}-${d.y}-${i}`}
                                // disabled={props.submission.in_profiling_stage}
                                onMouseEnter={() => {
                                    handleCalPointHover(calCurvePlot, calPointStates, i, "enter")
                                }}
                                onMouseLeave={() => {
                                    handleCalPointHover(calCurvePlot, calPointStates, i, "leave")
                                }}
                                onClick={() => {
                                    if (props.submission.in_profiling_stage || !d.chromatogram_validity) return
                                    handleCalPointStateChange(d, calCurvePlot)
                                }}
                            >
                                <div>
                                    <div className={`cal-check-state btn-sm btn-outline-dark ${d.selected ? 'text-success' : (d.chromatogram_validity ? "text-body-tertiary" : "text-warning")}`}>{`${d.selected ? 'Selected' : (d.chromatogram_validity ? "Unselected" : "Invalid Chromatogram")}`}</div>
                                </div>
                                <label className="form-check-label" style={{ marginLeft: '3px' }} htmlFor={`key-${d?.x}-${d?.y}-${i}`}>
                                    <span className="mx-2">{`Point ${parseInt(d.idx)}: [ ${d.x} µM, ${d.y?.toFixed(2)} ]`}</span>
                                </label>
                            </div>
                        )
                    }) : null}
                </div>
                <hr className="my-2" />
                <h5 className='mt-0'>Parameters:</h5>
                <div className="btn btn-outline-dark form-check d-flex align-items-center"
                    onClick={() => setApplyToAllAnalytes(!applyToAllAnalytes)}
                >
                    <input className="input"
                        type="checkbox"
                        style={{ marginTop: '3px' }}
                        checked={applyToAllAnalytes}
                        onChange={() => setApplyToAllAnalytes(!applyToAllAnalytes)}
                        value="apply-to-all"
                        key={`key-apply-to-all`} />
                    <label className="form-check-label" style={{ marginLeft: '3px' }} htmlFor={`key-apply-to-all`}>
                        <span className="mx-2">Apply to all analytes</span>
                    </label>
                </div>
                <hr className="my-2" />
                <div className="d-flex gap-1 w-100">
                    <button className="btn w-50 btn-danger p-2 my-2 shadow-sm"
                        // disabled={props.preprocessingComplete}
                        // disabled={true}
                        disabled={["Profiling", "Queued", "Preprocessing", "Profiled"].includes(props.submission.status)}
                        onClick={async () => {
                            if (confirm("Are you sure you want to reset the calibration points?")) {
                                resetCalPoints(props.SUBMISSION_ID, applyToAllAnalytes, props.selectedAnalyte.name, props.selectedAnalyte.id)
                                    .then((response) => {
                                        console.log("response from resetCalPoints: ", response)
                                        // reload page to update submission status and start polling for status
                                        window.location.reload()
                                    }
                                    )
                            } else {
                                return
                            }
                        }}
                    >
                        <RxReset className="mx-1 d-inline-block text-white align-text-bottom" style={{ fontSize: '1.2rem' }} />
                        Reset Calibration Points
                    </button>
                    <button className="btn w-50 btn-info p-2 my-2 shadow-sm"
                        // disabled={props.preprocessingComplete}
                        disabled={["Profiling", "Queued", "Preprocessing", "Profiled"].includes(props.submission.status)}
                        onClick={async () => {
                            console.log("calPointStates: ", calPointStates, "applyToAllAnalytes: ", applyToAllAnalytes)
                            if (calPointStates.filter((point) => point.selected).length < 2) {
                                alert("Please select at least 2 calibration points to recalibrate, or reset calibration points for all 7 points.")
                                return
                            }
                            let pointStatesString = calPointStates.map((point) => {
                                return `${point.idx}-${point.selected ? 1 : 0}`
                            })
                            console.log("RECALI", props)
                            recalibrateAnalyte(props.SUBMISSION_ID, props.selectedAnalyte.id, props.selectedAnalyte.name, pointStatesString, applyToAllAnalytes)
                                .then((response) => {
                                    // console.log("response from recalibrateAnalyte: ", response)
                                    // reload page to update submission status and start polling for status
                                    window.location.reload()
                                })
                        }}
                    >
                        <BiReset className="mx-1 d-inline-block align-text-bottom" style={{ fontSize: '1.2rem' }} />
                        Recalibrate Analyte
                    </button>
                </div>
            </div>
            <div className="pe-3 w-50">
                <div id={CAL_CURVE_ID}></div>
            </div>
        </div>
    )

}


function updateChromatogram(chart, selectionRange, originalData) {
    console.log("selectionRange: ", selectionRange)
    let newData = originalData.filter((d) => {
        return d['x'] >= selectionRange[0] && d['x'] <= selectionRange[1]
    })
    chart.updateSeries([
        {
            data: originalData,
        },
        {
            name: "Retention-Time-Window",
            data: newData,
        },
        // {
        //     data: // TODO: add the horizontal peak area line
        // }
    ])
}


function renderChromatogram(selectedSample, data, divId, title, analyteName, sampleFilename, chromSelection, setChromSelection, noiseLevel, rtMinIdxSetter, areaToUse, IS_FIA) {
    console.log("selectedSample from renderChromatogram>>>>>>: ", selectedSample)
    console.log("data from renderChromatogram>>>>>>: ", data)
    let sampleData, sampleIdx, rminIdx, rmaxIdx;
    if (title === EXP_CHROM_TITLE) {
        console.log("rendering exp chromatogram")
        sampleData = data
        rminIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmin)
        rmaxIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmax)
    } else if (title === ISTD_CHROM_TITLE) {
        console.log("rendering istd chromatogram")
        sampleData = data
        rminIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmin)
        rmaxIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmax)
    }
    rtMinIdxSetter(rminIdx)
    console.log("rminIdx, rmin", rminIdx, sampleData.values[rminIdx], sampleData.rmin)
    console.log("rmaxIdx, rmax", rmaxIdx, sampleData.values[rmaxIdx], sampleData.rmax)
    // console.log("data from renderChromatogram: ", data)
    let colors = {
        exp: {
            fill: ['rgba(246, 100, 110, 0.4)'],
            stroke: ['#F6646E'],
        },
        istd: {
            fill: ['rgba(69, 150, 182, 0.4)'],
            stroke: ['#4596B6'],
        },
    }
    // console.log("PLOTTTTTTTTTTTTTTTTT")
    let fillColors = ["transparent", "#ffffff", divId === CHROM_EXP_ID ? colors.exp.fill[0] : colors.istd.fill[0]]
    sampleFilename = sampleFilename.split('_').slice(5, -1).join('_')
    if (rminIdx > -1 && rmaxIdx > -1) {  // this means that the retention time window has been set
        let zoomedData = sampleData.values
        zoomedData = zoomedData.sort((a, b) => a.x - b.x).filter((d) => sampleData.values[rminIdx]['x'] - d.x < CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER && d.x - sampleData.values[rmaxIdx]['x'] < CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER)
        packagedData = zoomedData.map((d) => [d['x'], d['y']])
    } else if (rminIdx === rmaxIdx) {  // this means that the retention time window has not been set by backend (due to failure of peak picking), is usually just the first point
        packagedData = sampleData.values.map((d) => [d['x'], d['y']])

    } else {  // if any othe errors occur, just plot the entire chromatogram
        packagedData = sampleData.values.map((d) => [d['x'], d['y']])
    }
    let xValues = sampleData.values.map(d => d['x']);
    let yValues = sampleData.values.map(d => d['y']);

    console.log("AREATOUSE", areaToUse)
    console.log("AREATOUSE sampleData.values[rminIdx], sampleData.values[rmaxIdx]", sampleData.values[rminIdx], sampleData.values[rmaxIdx])
    console.log("AREATOUSE rminIdx, rmaxIdx", rminIdx, rmaxIdx)

    // Find the maximum and minimum values of 'x'
    let maxX = Math.max(...xValues);
    let minX = Math.min(...xValues);
    let maxY = Math.max(...yValues);
    console.log("Max X: ", maxX)
    console.log("Min X: ", minX)
    console.log("Max Y: ", maxY)
    let options = {
        series: [
            {
                name: "Retention Time",
                data: sampleData.values.map((d) => [d['x'], d['y']]),
                // data: packagedData,
                type: 'line',
            },
            {
                name: "Horizontal-RT-Line",
                data: !IS_FIA && areaToUse === "area_horizontal_raw" && rminIdx > - 1 && rmaxIdx > -1 ? [
                    [sampleData.values[rminIdx]['x'], sampleData.values[rminIdx]['y']],
                    [sampleData.values[rmaxIdx]['x'], sampleData.values[rmaxIdx]['y']]
                ] : [],
                type: 'area',
            },
            {
                name: "Retention-Time-Window",
                data: sampleData.values.map((d) => [d['x'], d['y']]).slice(rminIdx, rmaxIdx + 1),
                type: 'area',
                tooltip: {
                    enabled: false,
                }
            },
        ],
        chart: {
            type: 'line',
            stacked: true,
            height: Math.max(200, (window.innerHeight * 0.013) ** 2),
            zoom: {
                type: 'y',
                enabled: true,
                autoScaleYaxis: false
            },
            selection: {
                enabled: false,
            },
            toolbar: {
                show: true,
                autoSelected: 'selection',
                tools: {
                    // download: {
                    //     csv: true,
                    // },
                    selection: false,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true,
                }
            },
            events: {
                zoomed: function (chartContext, { xaxis, yaxis }) {
                    chart.updateOptions({
                        xaxis: {
                            type: 'numeric',
                            tickPlacement: 'on',
                            // tickAmount: (xaxis.max - xaxis.min) / 0.1,
                            title: {
                                text: 'Retention Time (mins)'
                            }
                        }
                    });
                }
                // selection: function (chart, e) {
                //     setChromSelection([e.xaxis.min, e.xaxis.max])
                //     console.log("min: ", e.xaxis.min, "max: ", e.xaxis.max)
                // },
            }
        },
        stroke: {
            curve: 'straight',
            colors: [divId === CHROM_EXP_ID ? colors.exp.stroke[0] : colors.istd.stroke[0], 'transparent', 'transparent'],
            width: 2,
        },
        dataLabels: {
            enabled: false
        },
        markers: {
            size: [1.5, 0],
            strokeWidth: 0.5,
            colors: "#f0e929",
            strokeColors: ["#000000"]
        },
        title: {
            // text: title + ` for ${analyteName}` + ` (${sampleFilename} [ID#${selectedSample}])`,
            text: `${title} [${sampleFilename}]`,
            align: 'left',
        },
        fill: {
            type: 'solid',
            colors: fillColors,
            opacity: 1,
        },
        yaxis: {
            title: {
                text: 'Intensity'
            },
            labels: {
                formatter: function (value) {
                    // return in exponential format
                    return value.toExponential(2)
                }
            }
        },
        xaxis: {
            type: 'numeric',
            tickPlacement: 'on',
            // tickAmount: (maxX - minX) / 0.1,
            tickAmount: 5,
            title: {
                text: 'Retention Time (mins)'
            },
            //range: 1,
        },
        legend: {
            show: false,
        },
        tooltip: {
            x: {
                formatter: (value) => `${parseFloat(value).toFixed(2)} min`,
            },
            y: {
                title: {
                    formatter: (seriesName) => `Intensity`,
                }
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return `<div class="card bg-info-subtle p-2 shadow-sm border-0">
                            <span>Intensity: ${parseFloat(series[0][dataPointIndex]).toExponential(2)}</span>
                        </div>`
            }
        },


    }

    console.log("noiseLevel: ", noiseLevel)
    if (noiseLevel["corrected"]) {
        options.annotations = {
            yaxis: [
                {
                    y: noiseLevel["noise_level"],
                    y2: 0,
                    borderColor: '#000',
                    fillColor: '#FEB019',
                    // label: {
                    //     text: `baseline: ${noiseLevel}`,
                    //     style: {
                    //         color: "#fff",
                    //         background: '#FEB019'
                    //     }
                    // }
                }
            ]
        }
    }

    let chart = new ApexCharts(document.getElementById(divId), options);
    chart.render();

    if (sampleData.rmin != sampleData.rmax) {
        minX = Math.max(sampleData.rmin - CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER, sampleData.values[0]['x'])
        maxX = Math.min(sampleData.rmax + CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER, sampleData.values[sampleData.values.length - 1]['x'])
        maxY = sampleData.values.slice(rminIdx, rmaxIdx + 1).reduce((max, point) => {
            return Math.max(max, point.y)
        }, Number.NEGATIVE_INFINITY)
        console.log("Values are min max max xxy ", minX, maxX, maxY)
        let xmaxY = sampleData.values.find(item => item.y === maxY);
        console.log(xmaxY['x'])
        minX = xmaxY['x'] - 0.5
        maxX = xmaxY['x'] + 0.5
        chart.updateOptions({
            yaxis: {
                title: {
                    text: 'Intensity'
                },
                labels: {
                    formatter: function (value) {
                        // return in exponential format
                        return value.toExponential(2)
                    }
                },
                max: maxY + CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER,
            }
        })
        chart.zoomX(minX, maxX)
    }

    console.log("RMIN, RMAX", sampleData.rmin, sampleData.rmax)
    // chart.updateOptions({
    //     chart: {
    //         events: {
    //             markerClick: function (event, chartContext, { seriesIndex, dataPointIndex, config }) {
    //                 if (seriesIndex === 1) {
    //                     dataPointIndex = dataPointIndex + rminIdx
    //                 }                
    //                 xValue = sampleData.values[dataPointIndex]['x']
    //                 console.log("xValue: ", xValue, "dataPointIndex: ", dataPointIndex)
    //                 updateNewRTAnnotations(chart, xValue, chromSelection, setChromSelection)
    //             }
    //         }
    //     }
    // })

    return chart;

}

function updateNewRTAnnotations(chart, rtX, annotations, setAnnotations) {
    window.chart = chart
    const annotationColor = "#5f93cf"
    function addLine(x, color, chart) {
        chart.addXaxisAnnotation({
            x: x,
            strokeDashArray: 0,
            borderColor: color,
            label: {
                borderColor: color,
                style: {
                    color: '#fff',
                    background: color,
                },
                text: `${x.toFixed(2)} min`,
                position: 'top',
                orientation: 'horizontal',
            }
        }, pushToMemory = true)
    }
    // const id = `new-rt-annotation-${rtX}`
    if (annotations.length === 0) {
        chart.clearAnnotations()
        addLine(rtX, annotationColor, chart)
        setAnnotations([rtX])
    } else if (annotations.length === 1 && rtX !== annotations[0]) {
        // addLine(rtX, annotationColor, chart)
        chart.clearAnnotations()
        chart.addXaxisAnnotation({
            x: Math.min(annotations[0], rtX),
            x2: Math.max(annotations[0], rtX),
            fillColor: annotationColor,
            opacity: 0.2,
            borderColor: annotationColor,
            label: {
                borderColor: annotationColor,
                style: {
                    color: '#fff',
                    background: annotationColor,
                },
                text: `${Math.min(annotations[0], rtX).toFixed(2)} - ${Math.max(annotations[0], rtX).toFixed(2)} min`,
                position: 'top',
                orientation: 'horizontal',
            }
        }, pushToMemory = true)

        setAnnotations(anno => [...anno, rtX])
    }

}



function renderCalCurve(data, divId, analyteName) {
    console.log("in renderCalCurve")
    console.log("data from renderCalCurve: ", data)
    // data['cal_points'] = JSON.parse(data['cal_points'])
    let options = {
        series: [{
            name: 'Calibration Points',
            type: 'scatter',
            data: data.cal_points
        }, {
            name: 'Best Fit Line',
            type: 'line',
            data: data.best_fit_line
        }],
        chart: {
            height: window.innerHeight * 0.385,
            type: 'line',
        },
        stroke: {
            colors: ["#F6646E"]
        },
        fill: {
            type: 'solid',
        },
        markers: {
            // size: [10, 0]
            discrete: data.cal_points.map((d, i) => {
                return {
                    seriesIndex: 0,
                    dataPointIndex: i,
                    fillColor: d.selected ? CAL_CURVE_MARKER_COLOR : CAL_CURVE_MARKER_COLOR_UNFILLED,
                    size: DEFAULT_CAL_CURVE_MARKER_SIZE,
                }
            })
        },
        tooltip: {
            shared: false,
            intersect: true,
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return `<div class="card border-0">
                            <div class="card-header bg-dark" style="color: white;">
                                <span style='font-size: 1.2rem; font-weight: bold; margin: 0; padding: 0'>Point ${dataPointIndex + 1}</span>
                            </div>
                            <div class="p-2 card" style="border-radius: 0px 0px 5px 5px;">
                                <span>Peak Area Ratio: ${series[seriesIndex][dataPointIndex].toFixed(2)}</span>
                                <span>Calibration Concentration (µM): ${data.cal_points[dataPointIndex].x}</span>
                            </div>
                        </div>`
            }
        },
        legend: {
            show: false
        },
        yaxis: {
            title: {
                text: 'Peak Area Ratio'
            },
            labels: {
                formatter: function (value) {
                    return value.toFixed(2)
                }
            },
            min: 0
        },
        xaxis: {
            type: 'numeric',
            title: {
                text: 'Calibration Concentration (µM)'
            },
            min: 0
        },
        title: {
            text: `Calibration Curve for ${analyteName}`,
            align: 'left',
        },
        noData: {
            text: 'No calibration curve data available for this analyte.',
        }
    };

    let chart = new ApexCharts(document.getElementById(divId), options);
    chart.render();



    return chart;

}




const AnalyteSelection = (props) => {
    const [fuseFilteredAnalytes, setFuseFilteredAnalytes] = React.useState(props.analytes);  // list of all analytes for fuse search
    const fuse = new Fuse(props.analytes, {
        keys: ["id", "name", "hmdb_id", "error"]
    })
    const analyteToScroll = React.useRef(null);
    const handleAnalyteSelect = (analyte) => {
        props.setSelectedAnalyte(analyte);  // Update the selected analyte
        setLastSelectedSample(
            props.SUBMISSION_ID,
            analyte.id,
            analyte.name,
            props.selectedSample
        )
            .then((response) => {
                console.log("Set last selected sample", response)
            })
    };

    const getRowStyle = (analyte) => {
        return analyte.id === props.selectedAnalyte?.id ? { backgroundColor: '#0dcaf0' } : {};
    };


    React.useEffect(() => {
        setFuseFilteredAnalytes(props.analytes)

    }, [props.analytes])

    React.useEffect(() => {
        // Scroll to the selected row when selectedAnalyte changes
        // https://github.com/facebook/react/issues/23396#issuecomment-1376887787
        const timer = setTimeout(() => {
            if (analyteToScroll.current) {
                analyteToScroll.current.scrollIntoView({
                    block: 'center',
                });
            }
        }, 0)
        console.log("SELECTED", props.selectedAnalyte)
    }, [props.selectedAnalyte])

    console.log("SUBMISSION", props.submission)

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "93vh" }}>
            <div className='d-flex flex-column gap-1 p-1'>
                {
                    <div className='d-flex gap-1'>
                        <button className="btn btn-info shadow-sm w-50" type="button"
                            disabled={props.preprocessingComplete || props.submission.status === "Profiling" || props.submission.status === "Queued_For_Profiling"}
                            onClick={async () => {
                                if (confirm("Are you sure you want to start profiling experimental samples? Once started, you will not be able to add/remove calibration points to recalibrate any analytes for this submission of data files.")) {
                                    props.setPreprocessingComplete(true)
                                    startProfiling(props.SUBMISSION_ID)
                                        .then((response) => {
                                            console.log("response from startProfiling: ", response)
                                            // reload page to update submission status and start polling for status
                                            window.location.reload()
                                        })
                                } else {
                                }
                            }}
                        >
                            <TbChartArrowsVertical className="mx-1 d-inline-block" style={{ fontSize: '1.2rem' }} />
                            Start Profiling
                        </button>

                        {/* {(props.preprocessingComplete || props.IS_FIA) && */}
                        <div className="d-flex align-items-center gap-2 w-50">
                            <div className="btn-group btn-group-sm" role="group">
                                <button type="button"
                                    className={`btn ${props.submissionFileFormat === 'csv' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => props.setSubmissionFileFormat('csv')}
                                >CSV</button>
                                <button type="button"
                                    className={`btn ${props.submissionFileFormat === 'xlsx' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => props.setSubmissionFileFormat('xlsx')}
                                >Excel</button>
                            </div>
                        </div>
                        <button className="btn btn-info shadow-sm w-50" id='download-btn'
                            disabled={props.submission.status !== "Profiled"}
                            onClick={() => {
                                // make spinner visible
                                document.getElementById('download-icon').classList.add('d-none')
                                document.getElementById('download-spinner').classList.remove('d-none')
                                document.getElementById('download-btn').disabled = true
                                fetch(`/download_submission_results?report[submission_id]=${props.submission.id}&file_type=${props.submissionFileFormat}`)
                                    .then((response) => response.json())
                                    .then((data) => {
                                        console.log("data from download_submission_results: ", data)
                                        let pollProgress = setInterval(() => {
                                            fetch(`/stats/report_progress?submission_id=${props.submission.id}`)
                                                .then((response) => response.json())
                                                .then((progressData) => {
                                                    console.log("progress data:", progressData)
                                                    if (progressData.status === 'completed') {
                                                        const url = `/get_generated_report?report_id=${encodeURIComponent(progressData.report_id)}`
                                                        window.location.assign(url)
                                                        document.getElementById('download-icon').classList.remove('d-none')
                                                        document.getElementById('download-spinner').classList.add('d-none')
                                                        document.getElementById('download-btn').disabled = false
                                                        clearInterval(pollProgress)
                                                    } else if (progressData.status === 'errored') {
                                                        console.error('Error generating report')
                                                        document.getElementById('download-icon').classList.remove('d-none')
                                                        document.getElementById('download-spinner').classList.add('d-none')
                                                        document.getElementById('download-btn').disabled = false
                                                        clearInterval(pollProgress)
                                                    }
                                                })
                                        }, 2000)
                                    })

                                // props.table.download('csv', `LC-Autofit-${props.selectedAnalyte.name}-${props.submission.project_name}-${props.submission.instrument}-${props.submission.kit_assay}-${props.submission.panel}-${props.submission.biofluid}.csv`)
                            }}
                        >
                            <FaDownload className='align-sup mx-1' id='download-icon' />
                            <div className='spinner-border spinner-border-sm d-none mx-1' role='status' id='download-spinner' />
                            Download Results
                        </button>
                        {/* <button className="btn btn-info shadow-sm w-50" type="button"
                        // disabled={!props.preprocessingComplete}
                        disabled={true}
                        >
                        <FaDownload className="mx-1 d-inline-block" style={{fontSize: '1.2rem'}}/>
                        Download Results
                    </button> */}
                    </div>
                }
                <div className=''>
                    <div className="d-flex justify-content-between fs-5 fw-bold border border-1 border-secondary-subtle rounded-top p-1" style={{ borderRadius: '3px 3px 0px 0px !important' }}>
                        {`Status: ${props.submission.status}`}
                        {["Profiling", "Preprocessing", "Queued"].includes(props.submission.status) &&
                            <span
                                className={` 
                                ${["Profiling", "Preprocessing"].includes(props.submission.status) ? 'spinner-border spinner-border-sm text-danger' : ''}
                                ${props.submission.status === "Queued" ? 'spinner-grow spinner-grow-sm text-warning' : ''}
                                align-baseline fs-5 mx-1
                            `}
                                style={{ alignSelf: 'center' }}
                            >
                            </span>
                        }
                    </div>

                    {props.submission.last_action_params &&
                        <div className='bg-body-secondary p-1 rounded-bottom-3'>
                            <div className='d-flex gap-1' style={{ flexFlow: 'column' }}>
                                <div className='bg-warning-subtle rounded px-1'>Action: {ACTION_TEXT[props.submission?.last_action_params?.action]}</div>
                                {props.IS_FIA ?
                                    <>
                                        <div className='bg-warning-subtle rounded px-1'>New window: {props.submission?.last_action_params?.new_window_fia}</div>
                                    </>
                                    :
                                    <>
                                        <div className='bg-warning-subtle rounded px-1'>Analyte: {props.submission?.last_action_params?.analyte_name}</div>
                                        {["apply_new_rt", "select_sample"].includes(props.submission.last_action_params.action) ? <div className='bg-warning-subtle rounded px-1'>Sample: {props.submission?.last_action_params?.sample_name}</div> : null}
                                        {["apply_new_rt", "apply_bc"].includes(props.submission.last_action_params.action) ? <div className='bg-warning-subtle rounded px-1'>Apply to all samples: {props.submission?.last_action_params?.apply_to_all_samples === 'true' ? <FaCheck /> : <FaBan />}</div> : null}
                                        {["cal_point_removal", "cal_point_reset"].includes(props.submission.last_action_params.action) ? <div className='bg-warning-subtle rounded px-1'>Apply to all analytes: {props.submission?.last_action_params?.apply_to_all_analytes === 'true' ? <FaCheck /> : <FaBan />}</div> : null}
                                    </>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className="analyte-selection-table" style={{ overflowY: "scroll", fontSize: "12px", flex: "1" }}>
                <table className="table table-hover" style={{ borderCollapse: "seperate" }}>
                    <thead style={{ position: "sticky", top: "0" }}>
                        <tr style={{ fontSize: "0.875rem" }}>
                            <th>HMDB ID</th>
                            <th>Analyte Name</th>
                            <th>Errors</th>
                        </tr>
                        <tr>
                            <th style={{ height: "1px", padding: "0", margin: "2px", backgroundColor: "#c4c8cb" }} colSpan="4"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.analytes.map((analyte, index) => (
                            <tr key={index} style={{ ...getRowStyle(analyte), fontSize: "0.75rem" }} className={`${props.selectedAnalyte.id === analyte.id ? "bg-danger" : ""}`} onClick={() => handleAnalyteSelect(analyte)} ref={props.selectedAnalyte.id === analyte.id ? analyteToScroll : null}>
                                <td style={getRowStyle(analyte)} className='py-1'><a href={HMDB_BASE_URL + analyte.hmdb_id} target={'_blank'} className='align-middle' onClick={(e) => e.stopPropagation()}>{analyte.hmdb_id}</a></td>
                                <td style={{ ...getRowStyle(analyte), fontSize: "0.875rem" }} className='py-1'>{analyte.name}</td>
                                <td style={getRowStyle(analyte)} className='py-1 text-center'>{analyte.dropdown_errors.length}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}




function renderInitialTable(tableEle,
    data,
    handleClickView,
    actionButtons,
    setSelectedSample,
    selectedSample,
    flags,
    selectedAnalyte,
    IS_FIA,
    IS_SCIEX
) {

    let cols = [
        // {title: "Analyte", field: "analyte", responsive: true, headerFilter: "input", headerFilterPlaceholder: "Search by analyte...", headerFilterFunc: "like", resizable: true},
        { title: "Analyte ID", field: "analyte_id", visible: false },
        { title: "Sample ID", field: "sample_id", visible: false, width: 50 },  // this is hidden as of Jan 8th but used to grab the correct sample chromatogram data while rendering the plot
        { title: "Analyte", field: "analyte_name", visible: false },
        //{title: "Flags", field: "flags", visible: false},
        {
            title: "Flags", field: "flags", visible: true, responsive: true, resizable: true, vertAlign: "middle", formatter(cell, formatterParams, onRendered) {
                if (JSON.stringify(cell.getValue()) !== '[]') {
                    let flagCodes = []
                    let jsonFlagData = JSON.parse(JSON.stringify(cell.getValue()))
                    jsonFlagData.map((flag) => {
                        flagCodes.push(flag.error)
                    })
                    return flagCodes.join(', ')
                }
                return ""
            }
        },
        {
            title: "Chromatogram", field: "click_view", hozAlign: "center",
            formatter: (cell, formatterParams, onRendered) => {
                return actionButtons(cell, formatterParams, onRendered, selectedSample)
            },
            cellClick: (e, cell) => {
                handleClickView(e, cell, setSelectedSample)
                table.deselectRow(); // Deselect all previously selected rows
                cell.getRow().toggleSelect()
            }, responsive: true, vertAlign: "middle", resizable: true
        },
        {
            title: "Sample File Name", field: "sample_filename", responsive: true, headerFilter: "input", vertAlign: "middle", headerFilterPlaceholder: "Search by sample...", headerFilterFunc: "like", resizable: true, formatter(cell, formatterParams, onRendered) {
                return cell.getValue().split('_').slice(5, -1).join('_')
            }
        },
        { title: "SN Ratio", field: "sn_ratio", visible: !IS_FIA, responsive: true, resizable: true, vertAlign: "middle" },
        { title: "Analyte Validity", field: "validity", visible: !IS_FIA, responsive: true, resizable: true, vertAlign: "middle" },
        { title: "ISTD Validity", field: "istd_validity", visible: false, responsive: true, resizable: true, vertAlign: "middle" },
        {
            title: "Accuracy", field: "accuracy", visible: !IS_FIA, responsive: true, resizable: true, vertAlign: "middle", formatter(cell, formatterParams, onRendered) {
                if (cell.getRow().getData().sample_filename.includes("Exp_") ||
                    cell.getRow().getData().sample_filename.includes("Double_Blank_dbl_blk_") ||
                    cell.getRow().getData().sample_filename.includes("Blank_blk_") ||
                    cell.getRow().getData().concentration < 0)
                    return "N/A"
                return parseFloat(cell.getValue()).toFixed(2)
            }
        },
        { title: "Analyte MRM", field: "analyte_mrm", visible: false, responsive: true, resizable: true, vertAlign: "middle" },
        {
            title: "Analyte PA", field: "analyte_pa", responsive: true, resizable: true, vertAlign: "middle", formatter(cell, formatterParams, onRendered) {
                return parseFloat(cell.getValue()).toExponential(2)
            }
        },
        { title: "ISTD", field: "istd", responsive: true, resizable: true, visible: false, vertAlign: "middle" }, // hidden as of Jan 8th
        { title: "ISTD MRM", field: "istd_mrm", responsive: true, resizable: true, visible: false, vertAlign: "middle" },
        {
            title: "ISTD PA", field: "istd_pa", responsive: true, resizable: true, vertAlign: "middle", formatter(cell, formatterParams, onRendered) {
                return parseFloat(cell.getValue()).toExponential(2)
            }
        },
        // {title: "Peak Area Ratio", field: "peak_area_ratio", visible:(!IS_FIA && !IS_SCIEX), responsive: true, resizable: true, vertAlign:"middle"},
        {
            title: "Peak Area Ratio", field: "peak_area_ratio", visible: true, responsive: true, resizable: true, vertAlign: "middle", formatter(cell, formatterParams, onRendered) {
                return parseFloat(cell.getValue()).toExponential(2)
            }
        },
        {
            title: "Concentration (µM)", field: "concentration", responsive: true, resizable: true, vertAlign: "middle", formatter(cell, formatterParams, onRendered) {
                // if < 0 or < LOD, return "< LOD"
                // if === 0 and is Blank or Double Blank, return "N/A" [changed to also < LOD]
                let data = cell.getRow().getData()
                let concentration = parseFloat(data.concentration)
                let lod = parseFloat(data.lod)
                if (concentration < lod) {
                    return `< LOD`
                } else {
                    return concentration.toExponential(2)
                    // return concentration.toFixed(2)
                }
                // return cell.getValue()
            }
        },
        {
            title: "LOD (µM)", field: "lod", responsive: true, resizable: true, vertAlign: "middle", formatter(cell, formatterParams, onRendered) {
                return parseFloat(cell.getValue()).toExponential(2)
            }
        },
        { title: "Blank PAR Avg.", field: "blank_par_avg", visible: false, responsive: true, resizable: true, vertAlign: "middle" },
        { title: "Blank Concentration Avg.", field: "blank_conc_avg", visible: false, responsive: true, resizable: true, vertAlign: "middle" },
        { title: "Blank Concentration Std.", field: "blank_conc_std", visible: false, responsive: true, resizable: true, vertAlign: "middle" },
    ]
    let table = new Tabulator(tableEle, {
        // maxHeight: (window.innerHeight * 0.05)**1.5,
        height: "47vh",
        layout: "fitColumns",
        rowHeight: 30,
        columnDefaults: {
            resizable: false,
        },
        data: data,
        columns: cols,
        initialSort: [
            { column: "sample_filename", dir: "asc" }
        ],
        selectableRows: true, //make rows selectable
        selectableRangeMode: "click", // Allow selecting a row by clicking on it
        renderVertical: "basic",  // Disabling will render all rows including non visable rows
        rowFormatter: function (row) {
            let sampleFlags = row.getData().flags  // list of flag objects for this sample and analyte ONLY
            let columns = sampleFlags.map(f => f.columns).flat()
            console.log("columns: ", columns)
            columns.map(c => {
                let cell = row.getCell(c)
                cell.getElement().style.backgroundColor = "#f7e5b0"
                cell.getElement().style.color = "#000000"
            })
        }
        // rowFormatter: function(row) {
        //     let sampleflags = flags[selectedAnalyte.name]?.sample_table_errors?.filter(sf => sf.sample_id === row.getData().sample_id)[0]

        //     sampleflags?.errors?.map(e => {
        //         let cell;
        //         if (["analyte_peak_under_noise_level", 
        //             "istd_peak_under_noise_level"].includes(e)) {  // need to specify the column names for these two error codes
        //             ["sample_filename", "click_view"].map(c => {
        //                 cell = row.getCell(c)
        //                 // cell.getElement().style.backgroundColor = "#e89099"
        //                 cell.getElement().style.backgroundColor = "#f7e5b0"
        //             }) 
        //         } else {
        //             e?.columns?.map(c => {
        //                 let bgColor;
        //                 switch (e) {
        //                     case "peak_area_ratio_calculation_error"
        //                     : bgColor = "#f7e5b0"
        //                     case "negative_concentration"
        //                     : bgColor = "#f7e5b0"
        //                     break;
        //                     case "analyte_not_found"
        //                     : bgColor = "#e89099"
        //                     break;
        //                     case "istd_not_found"
        //                     : bgColor = "#e89099"
        //                     break;
        //                     case "analyte_peak_under_noise_level"
        //                     : bgColor = "#f7e5b0"
        //                     break;
        //                     case "istd_peak_under_noise_level"
        //                         : bgColor = "#f7e5b0"
        //                         break;
        //                         case "experimental_outlier"
        //                         : bgColor = "#f7e5b0"
        //                         break;
        //                         default
        //                         : bgColor = "#f7e5b0"
        //                         break;
        //                 }
        //                 cell = row.getCell(c)
        //                 cell ? cell.getElement().style.backgroundColor = bgColor : null

        //             }) 
        //         }
        //     })
        //     let rowData = row.getData()
        //     console.log("rowData: ", rowData['concentration'])
        //     if (parseFloat(rowData['concentration']) < 0 && !rowData['sample_filename'].includes("Blank_")) {
        //         row.getCell('concentration').getElement().style.backgroundColor = "#e89099"
        //     }
        // },
    })

    tableEle.style.borderRadius = "5px";

    return table
}


function findClosestIndex(array, target) {
    if (array.length === 0) return -1
    let closestIdx = 0
    let closestDiff = Math.abs(target - array[0])
    for (let i = 1; i < array.length; i++) {
        let diff = Math.abs(target - array[i])
        if (diff < closestDiff) {
            closestIdx = i
            closestDiff = diff
        }
    }
    return closestIdx
}